<template>
  <div>
    <svg
      width="45"
      height="45"
      viewBox="0 0 56 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#341661"
        d="M29.028 0.0199937C28 -0.0238935 27.244 0.0199937 26.832 0.0199937C22.356 0.0918092 0 4.14539 0 27.7009C0 44.9246 16.776 62.1284 24.84 70.4032C25.6 71.1852 26.296 71.8913 26.892 72.5217C27.18 72.8249 27.588 73.0005 28 73.0005C28.412 73.0005 28.828 72.8289 29.108 72.5217C29.704 71.8913 30.396 71.1852 31.16 70.4032C39.224 62.1364 56 44.9326 56 27.7089C56.008 4.14539 33.82 0.111758 29.332 0.0399425L29.028 0.0199937Z"
      />
      <rect x="34.4006" y="19.1805" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="34.4006" y="25.0558" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="34.4006" y="30.931" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="25.5376" y="19.1805" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="25.5376" y="25.0558" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="25.5376" y="30.931" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="16.676" y="19.1805" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="16.676" y="25.0558" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="16.676" y="30.931" width="4.92298" height="2.93765" fill="#FEFEFE" />
      <rect x="10.769" y="16.2427" width="2.95379" height="20.5636" fill="#FEFEFE" />
      <rect x="42.2773" y="16.2427" width="2.95379" height="20.5636" fill="#FEFEFE" />
      <rect x="8.80029" y="36.8064" width="38.3998" height="2.93769" fill="#FEFEFE" />
      <rect x="21.7722" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="18.6599" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="15.5459" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="12.4321" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="24.886" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="27.9998" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="31.1138" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="34.2273" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="37.3396" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="40.4536" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="9.83789" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="8.80005" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="42.01" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
      <rect x="44.0854" y="13.3049" width="3.11345" height="2.93765" fill="#FEFEFE" />
    </svg>
  </div>
</template>

<script>
export default {};
</script>
